import React, { useEffect, useState } from 'react';
import axios from 'axios';
import dayjs from 'dayjs';

import EmployeeList from './mainCard';
import Tasks from './tasks';
import { DemoCalendar } from './calender';
import UpcomingBirtday from './upcomingBirtday';
import Notes from './notes';

export default function Dashboard() {
  const [employeeCount, setEmployeeCount] = useState("0");
  const [attendanceCount, setAttendanceCount] = useState("0");
  const [leaveCount, setLeaveCount] = useState("0");

  const token = localStorage.getItem("accessToken");

  // Fetch HRMS data (Total Employees, Attendance, Leaves)
  useEffect(() => {
    const fetchData = async () => {
      const today = dayjs().format("YYYY-MM-DD");
      try {
        const attRes = await axios.get(
          `${process.env.REACT_APP_API}/api/attendance/attendance/?start_date=${today}&end_date=${today}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setAttendanceCount(attRes.data?.length || "0");

        const leaveRes = await axios.get(
          `${process.env.REACT_APP_API}/api/leavemanagement/leaves/filter_by_date/?start_date=${today}&end_date=${today}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setLeaveCount((leaveRes.data?.length - 1) || "0");
      } catch (error) {
        console.error("Dashboard data fetch error:", error);
      }
    };
    if (token) fetchData();
  }, [token]);

  return (
    <div className="dashboard-container" style={{ padding: '0px 0px', width: '100%', overflowX: 'hidden' }}>
      {/* Top 3 Metric Cards */}
      <div className="row g-4 mb-4">
        <div className="col-md-4">
          <div className="modern-card position-relative" style={{ background: 'var(--primary-color)', color: 'white', borderRadius: '24px', padding: '24px' }}>
            <div className="d-flex justify-content-between mb-2">
              <span style={{ fontSize: '15px', fontWeight: 500 }}>Total Employees</span>
              <div style={{ background: 'rgba(255,255,255,0.2)', borderRadius: '50%', width: '32px', height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <i className="bi bi-people"></i>
              </div>
            </div>
            <h1 style={{ fontSize: '42px', fontWeight: 600, margin: '16px 0' }}>{employeeCount}</h1>
            <div style={{ fontSize: '12px', display: 'flex', alignItems: 'center', gap: '6px' }}>
              <span style={{ background: 'rgba(255,255,255,0.2)', padding: '2px 6px', borderRadius: '12px' }}><i className="bi bi-person-check"></i></span> Active workforce
            </div>
          </div>
        </div>

        <div className="col-md-4">
          <div className="modern-card position-relative" style={{ background: '#ffffff', border: '1px solid #f0f0f0', borderRadius: '24px', padding: '24px' }}>
            <div className="d-flex justify-content-between mb-2">
              <span style={{ fontSize: '15px', fontWeight: 500, color: 'var(--primary-color)' }}>Today Attendance</span>
              <div style={{ background: 'var(--bg-color)', color: 'var(--text-main)', borderRadius: '50%', width: '32px', height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <i className="bi bi-calendar-check"></i>
              </div>
            </div>
            <h1 style={{ fontSize: '42px', fontWeight: 600, margin: '16px 0', color: 'var(--primary-color)' }}>{attendanceCount}</h1>
            <div style={{ fontSize: '12px', color: 'var(--text-muted)', display: 'flex', alignItems: 'center', gap: '6px' }}>
              <span style={{ background: 'var(--bg-color)', color: 'var(--primary-color)', padding: '2px 6px', borderRadius: '12px' }}><i className="bi bi-clock-history"></i></span> Logged in today
            </div>
          </div>
        </div>

        <div className="col-md-4">
          <div className="modern-card position-relative" style={{ background: '#ffffff', border: '1px solid #f0f0f0', borderRadius: '24px', padding: '24px' }}>
            <div className="d-flex justify-content-between mb-2">
              <span style={{ fontSize: '15px', fontWeight: 500, color: 'var(--text-main)' }}>Today Leaves</span>
              <div style={{ background: 'var(--bg-color)', color: 'var(--text-main)', borderRadius: '50%', width: '32px', height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <i className="bi bi-calendar-x"></i>
              </div>
            </div>
            <h1 style={{ fontSize: '42px', fontWeight: 600, margin: '16px 0', color: 'var(--error-color)' }}>{leaveCount}</h1>
            <div style={{ fontSize: '13px', color: 'var(--primary-color)', fontWeight: 500, display: 'flex', alignItems: 'center', gap: '6px' }}>
              Employees on leave
            </div>
          </div>
        </div>
      </div>

      {/* Main Grid for Real User Components */}
      <div className="row g-4 mb-4">
        {/* Left Column (Wide) */}
        <div className="col-xl-8 col-lg-12 d-flex flex-column gap-4">
          <Tasks />
          <EmployeeList setEmployeeCount={setEmployeeCount} />
        </div>

        {/* Right Column (Narrow) */}
        <div className="col-xl-4 col-lg-12 d-flex flex-column gap-4">
          <Notes />
          <DemoCalendar />
          <UpcomingBirtday />
        </div>
      </div>

    </div>
  );
}
